export const enum DriverApplicationStatusEnum {
  Rejected = 34,
  DrugTest = 55
}

export const enum OnDemandApplicationDriverStatusEnum {
  Suspended = 46,
  Approved = 33
}

export const enum ProviderDriverStatusEnum {
  Approved = 4,
  Suspended = 5,
  Rejected = 6
}



// WEBPACK FOOTER //
// ./src/app/core/enums/driver.enum.ts